module.exports = __webpack_public_path__ + "static/media/quiet_mode_off.f70b9a7b.svg";